import { render, staticRenderFns } from "./MenuCategory.vue?vue&type=template&id=17e0b699"
import script from "./MenuCategory.vue?vue&type=script&lang=js"
export * from "./MenuCategory.vue?vue&type=script&lang=js"
import style0 from "./MenuCategory.vue?vue&type=style&index=0&id=17e0b699&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports